import React from "react";
import {Helmet} from "react-helmet";
import {CssBaseline} from "@material-ui/core";
import PageHeader from "../layouts/common/PageHeader";

const GamePage: React.FC = () => {


    return (<div style={{
            display: 'flex',
            flex: 1,
            flexDirection: "column"
        }}>

            <Helmet>
                <title>Lets play some game</title>
            </Helmet>


            <CssBaseline/>
            <PageHeader pageTitle={"Let's play Asteroids"}/>

            <div style={{flex: 1}}>
                <iframe title={"fun fun function"} style={{
                    position: "fixed",
                    width: "100%",
                    height: "100%",
                    left: 0,
                    top: 106
                }}
                        src={"https://chriz001.github.io/Reacteroids/"}/>
            </div>

        </div>
    );


};


export default GamePage;

